import ThinkChinaLogo from "@assets/logo@2x.svg?react";
import ThinkChinaLogoOnDark from "@assets/logo-on-dark.png";
import Link from "@components/Link";
import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";

type LogoProps = {
  theme?: ThemeEnum;
  minimized?: boolean;
};

export default function Logo({
  theme = ThemeEnum.light,
  minimized,
}: LogoProps) {
  if (minimized) {
    return null;
  }

  const isDefault = theme === ThemeEnum.light;
  return (
    <Link
      to="/"
      className="h-[40px] w-[134px] shrink-0 lg:h-[42px] lg:w-[140px] xl:h-[78px] xl:w-[260px]"
    >
      {isDefault && <ThinkChinaLogo className="size-full" />}
      {!isDefault && (
        <img
          src={ThinkChinaLogoOnDark}
          alt="ThinkChina Logo"
          className="size-full"
        />
      )}
    </Link>
  );
}
